module.exports = __webpack_public_path__ + "images/jamsheed.jpg?v=ef5669081ca6c0afc1b34dacd2730c8c";